'use strict';

export default {
  methods: {
    login () {
    },

    logout (store, router, loading) {
      this.$service.get(`system/salir`).then(response => {
        if (response.logoutUrl) {
          window.location.href = response.logoutUrl;
        } else {
          store = store || this.$store;
          router = router || this.$router;
          loading = loading || this.$loading;

          this.$storage.removeUser();
          this.$storage.remove('token');
          this.$storage.remove('user');
          this.$storage.remove('tipos_djbr_ex');
          this.$storage.remove('tipos_pdf-1');
          this.$storage.remove('tipos_pdf-2');
          this.$storage.remove('tipos_codigoPais');
          this.$storage.remove('tipos_codigoCargo');
          this.$storage.remove('codigoTipoServidorPublico');
          this.$storage.remove('ex');
          this.$storage.remove('ctrl');
          this.$storage.remove('codigoCargo');
          this.$storage.remove('codigoPais');
          this.$storage.remove('estado_civil');
          this.$storage.remove('pdf-2');
          this.$storage.remove('pdf-1');
          this.$storage.remove('ingreso');
          window.localStorage.removeItem('pdf-2');
          window.localStorage.removeItem('pdf-1');
          if (loading) {
            loading.hide();
          }

          this.cleanData(store);
          // El logout redirecionara a / que es el portal
          router.push('/').catch(() => {});
        }
      });
    },

    cleanData (store) {
      store.commit('setDefault');
      store.commit('DESTROY_INTERVAL');
      // Debemos resetear todos los formularios que usamos con vuex-map-fields
      store.commit('usuario/cleanForm');
    },

    timerSession () {
      // Definiendo el tiempo en el que dura una sesión sin actividad
      this.$store.commit('SET_TIME', process.env.TIME_SESSION_EXPIRED * 60);
      this.$store.commit('INIT_INTERVAL', window.setInterval(() => {
        let usr = this.$storage.getUser();
        if (usr === null) {
          this.logout();
        }
        this.$store.commit('TIME_DECREASE');
        if (this.$store.state.time <= 0) {
          this.$message.warning('Su sesión ha sido cerrada automáticamente después de ' + process.env.TIME_SESSION_EXPIRED + ' minutos de inactividad.', '¡Sesión cerrada!', { timeout: 30000 });
          this.logout();
        }
      }, 15000));
    },

    reload () {
      this.$store.commit('setMain', false);
      this.$nextTick(function () {
        this.$store.commit('setMain', true);
      });
    },
    getCode () {
      this.$http.get(`${this.$apiUrl}public/codigo`).then(response => {
        if (response) {
          this.$storage.setSession('tokenStateNonce', {
            token: response.data.datos.token
          });
          window.location.href = response.data.datos.url;
        }
      }).catch((error) => {
        this.$message.error(error.response.data.datos.message || 'Datos para ingreso con Ciudadania no encontrados.');
      });
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/admin/auth/mixins/auth.js